import React from "react";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import colors from "./theme/foundations/colors";
import { OverviewIcon } from "services/Recruit/assets/svg/overview";
import { KeyPasswordIcon } from "services/Recruit/assets/svg/keyPassword";
import { EmailIcon } from "services/Recruit/assets/svg/EmailIcon";
import { TbPlugConnected } from "react-icons/tb";
import { MdAdminPanelSettings } from "react-icons/md";

export const constant = {
  outlookAccessToken: "outlook_access_token",
  googleSignedIn: "googleSignedIn",
  refreshToken: "refresh_token",
  responseType: "code",
  role: 'Role',
  responseMode: "query",
  codeVerifier: "code-verifier",
  authCode: "auth-code",
  authorizationCode: "authorization_code",
  authCodeUrl: process.env.REACT_APP_AZURE_AUTH_CODE_URL,
  oauthUrl: process.env.REACT_APP_AZURE_OAUTH_URL,
  codeChallengeMethod: process.env.REACT_APP_AZURE_CODE_CHALLENGE_METHOD,
  baseUrl: process.env.REACT_APP_BASE_URL,
  clientID: process.env.REACT_APP_AZURE_CLIENT_ID,
  authority: process.env.REACT_APP_AZURE_AUTHORITY,
  redirectPath: process.env.REACT_APP_AZURE_REDIRECT_PATH,
  endpoint: process.env.REACT_APP_AZURE_GRAPH_ENDPOINT,
  scope: process.env.REACT_APP_AZURE_SCOPE,
  sessionType: process.env.REACT_APP_AZURE_SESSION_TYPE,
  recoilDuplicateAtomKeyCheckingEnabled:
    process.env.REACT_APP_AZURE_RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED,
  somethingWrong: "Something went wrong",
  add: "Add",
  folderExplorer: "File Explorer",
  statusOption: [
    { label: "New", value: 100, color: colors.new },
    { label: "In review", value: 100, color: colors.inReview },
    { label: "Available", value: 100, color: colors.available },
    { label: "Engaged", value: 100, color: colors.engaged },
    { label: "Offered", value: 100, color: colors.offered },
    { label: "Hired", value: 100, color: colors.available },
    { label: "Rejected", value: 100, color: colors.rejected },
  ],
  create: "Create",
  listView: "List View",
  tableView: "Kanban View",
  selectView: "Select View",
  view: "View",
  exportSelectedDataAsCSV: "Export Selected Data as CSV",
  exportAsCSV: "Export as CSV",
  exportSelectedDataAsExcel: "Export Selected Data as Excel",
  exportAsExcel: "Export as Excel",
  manageColumns: "Manage Columns",
  import: "Import",
  noOptionAvailable: "No options available",
  newCustomView: "New custom view",
  filterSelectList: [
    { value: "all", label: "All title" },
    { value: "locked", label: "All locked title" },
    { value: "converted", label: `Converted title` },
    { value: "junk", label: `Junk title` },
    { value: "mailing", label: `Mailing title` },
    { value: "my_converted", label: `My converted title` },
    { value: "my", label: `My title` },
    { value: "not_qualified", label: `Not qualified title` },
    { value: "open", label: `Open title` },
    { value: "recently_created", label: `Recently created title` },
    { value: "recently_modified", label: `Recently modified title` },
    { value: "today", label: `Today title` },
    { value: "unread", label: `Unread title` },
    { value: "unsubscribed", label: `Unsubscribed title` },
  ],
  selectAnOption: "Select an option",
  action: "Action",
  actionSelectList: [
    { value: "mass_delete", label: `Mass delete` },
    { value: "mass_update", label: `Mass update` },
    { value: "mass_convert", label: `Mass convert` },
    { value: "draft", label: `Draft` },
    { value: "mass_email", label: `Mass email` },
    { value: "autoresponder", label: `Autoresponders` },
    { value: "approve", label: `Approve title` },
    { value: "duplicate", label: `Duplicate title` },
    { value: "add_campaign", label: `Add to campaign` },
    { value: "create_client_script", label: `Create client script` },
    { value: "export", label: `Export title` },
  ],
  filter: "Filter",
  search: "Search",
  selectDate: "Select Date",
  jobOpenings: "Job Openings",
  targetDate: "Target Date",
  targetDateAccessor: "targetDate",
  createJobOpening: "Create Job Opening",
  jobOpening: "Job Opening",
  postingTitle: "Posting Title",
  enterPostingTitle: "Enter Posting Title",
  departmentName: "Department Name",
  enterDepartmentName: "Enter Department Name",
  title: "Title",
  hiringManager: "Hiring Manager",
  hiringManagerValue: "hiringManager",
  assignedRecruiter: "Assigned Recruiter",
  numberOfPosition: "Number of Positions",
  enterNumber: "Enter Number",
  dateOpened: "Date Opened",
  jobOpeningStatus: "Job Opening Status",
  selectJobOpeningStatus: "Select Job Opening Status",
  jobType: "Job Type",
  industry: "Industry",
  workExp: "Experience",
  salary: "Salary",
  salaryPerAnnum: "Salary per annum",
  requiredSkills: "Required Skills",
  next: "Next",
  city: "City",
  state: "State",
  stateAndTerritory: "State/Union Territory",
  country: "Country",
  zipCode: "PIN Code",
  enterCode: "Enter Code",
  back: "Back",
  jobDescription: "Job Description",
  requirements: "Requirements",
  benefits: "Benefits",
  jobSummary: "Job Summary",
  attachment: "Attachment",
  noFileChoosen: "No file chosen.",
  save: "Save",
  others: "Others",
  chooseJobTemp: "Choose job template",
  update: "Update",
  close: "Close",
  editDepartment: "Edit Department",
  edit: "Edit",
  delete: "Delete",
  share: "Share",
  actions: "Actions",
  selectDepartment: "Select Department",
  selectHiringManager: "Select Hiring Manager",
  selectAssignedRecruiter: "Select Assigned Recruiter",
  enterCity: "Enter City",
  selectState: "Select State",
  fileUploadedSuccessfully: "File uploaded successfully!",
  fileUploadFailed: "File upload failed",
  somethingWentWrong: "Something went wrong",
  uploadFailed: "Upload failed",
  failedToLoadDepartments: "Failed to load departments",
  failedToLoadApplications: "Failed to load Applications",
  notAllowed: "N/A",
  jobOpeningCreatedSuccess: "Job Opening Created successfully!",
  candidateCreatedSuccess: "Candidate Created successfully!",
  companyPolicyCreateSuccess: "Policy created successfully",
  referralCreatedSuccess: "Referral Created successfully!",
  failedToAddProfile: "Failed to add profile",
  apiReqFailed: "API request failed",
  failedToLoadUser: "Failed to load users",
  candidateStage: "Candidate Stage",
  candidateName: "Candidate Name",
  createCandidate: "Candidate",
  offerLetter: "Offer Letter",
  modifyTime: "Modify Time",
  source: "Source",
  candidateOwner: "Candidate Owner",
  rating: "Rating",
  bulkImportCandidate: "Bulk Import Candidate",
  upload: "Update",
  uploadExcelorCsv: "Upload Excel (.xlsx, .xls) or CSV file",
  maximumFileSize5: "Maximum file size is 5MB",
  actionAll: "All",
  contacted: "Contacted",
  applyFilterBtn: "Apply Filter",
  allSelectOptions: [
    { value: "cold_lead", label: `Cold Lead` },
    { value: "advertisement", label: `Advertisement` },
    { value: "web_download", label: `Web Download` },
    { value: "online", label: `Online` },
  ],
  langugageSelector: {
    english: "English",
    hindi: "Hindi",
    en: "en",
    hi: "hi",
  },
  invalidDate: "Invalid Date",
  status: "Status",
  statusAccessor: "status",
  postingTitleAccessor: "title",
  assignedRecruiterAccessor: "assignedRecruiter",
  department: "Department",
  departmentAccessor: "department",
  hiringManagerAccessor: "hiringManager",
  editJobProfile: "Edit Job Profile",
  name: "Manage360",
  editJobOpening: "Edit Job Opening",
  something_went_wrong: "Something went wrong",
  interview: "Interview",
  createInterview: "Create Interview",
  editInterview: "Edit Interview",
  interviewName: "Interview name",
  interviewer: "Interviewer",
  scheduleDateTime: "Schedule Date And Time",
  interviewRound: "Interview Round",
  commentForInterviewer: "Comment for Interviewer",
  commentForCandidate: "Comment for Candidate",
  interviewerFeedback: "Interviewer Feedback",
  candidate: "Candidate's Name",
  round: "Round",
  interviewType: "Interview Type",
  jobTitle: "Job Title",
  candidateEmail: "Candidate's Email",
  candidatePhoneNo: "Candidate's Phone Number",
  jobProfile: "Job Profile",
  namePlaceHolder: "Enter Name",
  nameLabel: "Name",
  emailPLaceHolder: "Enter email",
  emailLabel: "Email",
  phoneLabel: "Phone",
  phonePlaceHolder: "Enter Phone",
  locationLabel: "Location",
  totalExperience: "Total experience",
  currentLOcationLabel: "Current Location",
  currentLocation: "Enter current location ",
  noticePeriod: "Notice period",
  applicationSource: "Application source",
  CoverLetter: "Cover Letter",
  overview: "Overview",
  requiredTitle: "Title is required",
  requiredDepartment: "Department is required",
  requiredHiringManager: "Hiring Manager is required",
  requiredAssignedRecruiter: "Assigned Recruiter is required",
  requiredIndustry: "Industry is required",
  requiredSalary: "Salary is required",
  requiredDescription: "Description is required",
  requiredRequirements: "Requirements are required",
  requiredBenefits: "Benefits are required",
  selectInterviewer: "Select Interviewer",
  selectRound: "Select Round",
  selectInterviewType: "Select Interview Type",
  selectCandidate: "Select Candidate",
  advanceSearch: " Advance Search",
  jobApplicationTitle: "Job Application",
  jobApplication: "JobApplication",
  createJobApplication: "Create Job Application",
  editJobApplication: "Edit Application",
  currentLocationLabel: "Current Location",
  date: "Date",
  applicationId: "Application Id",
  createApplication: "Create Application",
  candidateDetail: "Candidate detail",
  selectTitle: "Select Title",
  job: "Job",
  enterLocation: "Enter Location",
  totalExp: "Total Experience",
  selectTotalExp: "Select Total Experience",
  selectCurrentLocation: "Select Current Location",
  enterNoticePerios: "Enter Notice Period",
  selectStatus: "Select Status",
  selectApplicationSource: "Select Application Source",
  selectJob: "Select Job",
  requiredJob: "Job is required",
  requiredName: "Name is required",
  requiredPhone: "Phone is required",
  requiredLocation: "Location is required",
  requiredCity: "City is required",
  requiredState: "State is required",
  applicationName: "Application Name",
  remindBefore: "Remind Before",
  remindBeforePlaceholder: "Enter Remind Before",
  reminderOptionSelect: "Select Reminder Option",
  reminderOption: "Reminder Option",
  notifyCandidate: "Notify candidate",
  setReminder: "Set Reminder",
  startOn: "Start On",
  startTime: "Start Time",
  selectTime: "Select Time",
  pending: "Pending",
  withdraw: "Withdraw",
  accept: "Accept",
  expired: "Expired",
  decline: "Decline",
  draft: "Draft",
  createCall: "Create Call",
  emailSend: "EmailSend",
  createOfferLetter: "Create Offer Letter",
  jobapplicant: "Job Applicant",
  offerExpireOn: "Offer Expire On",
  expectedJoiningDate: "Expected Joining Date",
  rate: "Rate",
  description: "Description",
  selectSalaryComponents: "Select Salary Components",
  salaryStructure: "Salary Structure",
  annualCTC: "Annual CTC",
  basicSalary: "Basic Salary",
  specialAllowance: "Special Allowance",
  basicValueType: "Basic Value Type",
  grossSalary: "Gross Salary",
  signaturerequired: "Signature Required",
  addSalaryStructure: "Add Salary Structure",
  fixed: "Fixed",
  percentage: "Percentage",
  salaryValue: 100,
  salaryComponent: "Salary Component",
  calculationType: "Calculation Type",
  MonthlyAmount: "Monthly Amount",
  Annualamount: "Annual Amount",
  statistics: "Statistics",
  leadStatistics: "Lead Statistics",
  totalLeads: "Total Leads",
  newLeads: "New Leads",
  bulkImport: "Bulk Import",
  contactedLeads: "Contacted Leads",
  qualifiedLeads: "Qualified Leads",
  new: "new",
  newValue: "New",
  contactedValue: "contacted",
  qualifiedValue: "Qualified",
  qualified: "qualified",
  taskStatics: " Task Statistics",
  totalTask: "Total Tasks",
  firstName: "First Name",
  lastName: "Last Name",
  phoneNumber: "Phone Number",
  userEmail: "User Email",
  welcomeTo: "Welcome to",
  manage360: "Manage360",
  CRM: "CRM",
  CRMDesc:
    "CRM enables contact management, sales, leads, email, analytics, reports, automation, support.",
  vault: "Vault",
  vaultDesc:
    "Vault password secures encrypted data, credentials, and info from threats.",
  recruitment: "Recruitment",
  recruitmentDesc:
    "Recruiting involves attracting, screening, and hiring candidates for jobs. It ensures organizations find skilled talent to meet workforce needs efficiently.",
  userName: "User Name",
  password: "Password",
  checkbox: "Checkbox",
  permission: "Permission",
  manage: "Manage",
  select: "Select",
  createDepartment: "Create Department",
  enterJobOpening: "Enter Job Opening",
  departments: "Departments",
  enterDescription: "Enter Description",
  taskTitle: "Title",
  taskRelatedTo: "Related To",
  taskStart: "Start Date",
  taskEnd: "End Date",
  taskLink: "Link",
  taskReminder: "Reminder",
  assignmentTo: "Assign To",
  assignedTo: "Assigned To",
  taskCreateBy: "Created By",
  taskDescription: "Description",
  taskNotes: "Notes",
  uploadFiles: "Upload Files",
  uploadFilesDesc:
    "Accepted File Types (Images, PDFs, Word docs, Powerpoint, Excel, ZIP, and video files - 15MB max)",
  sender: "Sender",
  recipent: "Recipient",
  createdTo: "Create to",
  recipentName: "Recipient Name",
  recipentPhoneNumber: "Recipient Phone Number",
  relatedTo: "Related To",
  startDate: "Start Date",
  application: "Application",
  deletedSuccessfully: "Deleted Successfully",
  endDate: "End Date",
  send: "Send",
  timestamp: "Timestamp",
  callDuration: "Call Duration",
  callNotes: "Call Notes",
  referrals: "Referrals",
  roles: "Roles",
  referralUrl: "referrals",
  mypassword: "my-password",
  deleteDesc: "Are you sure you want to delete selected",
  subject: "Subject",
  message: "Message",
  sendEmail: "Send Email",
  accountErrorMsg: "Please select account",
  dealErrorMsg: "Please select deal",
  fileName: "File Name",
  folderName: "Folder Name",
  selectInterestedProperty: "Select Interested Product",
  uploadTitle: "Upload",
  uploadDesc: "Accepted File Types (Images files - 15MB max) only 10 files",
  pleaseSelect: "Please Select",
  selectedFiles: "Selected Files",
  assignToContact: "Assign To Contact",
  assignToAccount: "Assign To Account",
  assignToLead: "Assign To Lead",
  bgcolor: "Background-Color",
  assignToDeal: "Assign To Deal",
  deal: "Deal",
  borderolor: "Border-Color",
  textColor: "Text-Color",
  url: "URL",
  notes: "Notes",
  uploadResume: "Upload Resume",
  resume: "Resume",
  robRecommendation: " Job Recommendation",
  referringForJob: "Referring For Job",
  email: "Email",
  currentJobTitle: "Current Job Title ",
  currentEmployer: "Current Employer",
  submitReferral: " Submit",
  cancel: "Cancel",
  referAcandidate: "Refer a candidate",
  none: "None",
  contact: "Contact",
  lead: "Lead",
  account: "Account",
  accounts: "Accounts",
  deals: "Deals",
  campgain: "Campgain",
  createCampgain: "Create Campgain",
  emailViewPage: "View page",
  createOrganization: "Create Your Organization",
  createOrganizationDesc:
    "Collaborate with your team to manage customer relations.",
  saveContinue: "Save & Continue",
  syncEmailAndCalendar: "Sync Emails & Calendar",
  syncGoogle: " Sync with Google",
  syncOutlook: "Sync with Outlook",
  inviteTeam: "Invite Your Team",
  setPssword: "Set your password",
  signUpText: "Sign Up",
  signUpDesc: "Collaborate with your team to manage customer relations.",
  organizationLogo: "Organization Logo",
  logoSupportText: "We support your square PNGs, JPEGs and GIFs under 10MB",
  organization: "Organization",
  nameOfOrganization: "The name of your organization",
  companyName: "Company Name",
  googleSync: "Google Sync",
  microsoftSync: "Microsoft Sync",
  enterEmail: "Enter Email",

  to: "To",
  from: "From",
  body: "Body",
  deleteJobAllication: "Deleted successfully",
  selectToRead: "Select an item to read",
  nothingSelected: "Nothing is selected",
  passwordViewPage: "Password View Page",
  createMeeting: "Create Meeting",
  meetingDetails: "Meeting Details",
  callDetails: "Call Details",
  details: "Details",
  createContact: "Create Contact",
  createEmail: "Create Email",
  createLead: "Create Lead",
  createProperty: "Create Property",
  addPassword: "Add Password",
  readOnly: "Read Only",
  readAndWrite: "Read & Write",
  manageAccess: "manage",
  copied: "Copied!",
  viewPassword: "View Password",
  jobOpeningID: "Job Opening ID",
  jobOpeningId: "jobOpeningId",
  campaign: "Campaign",
  createCampaign: "Create Campaign",
  campaignOwner: "Campaign owner",
  type: "Type",
  campaignName: "Campaign name",
  expectedRevenue: "Expected revenue",
  budgetCost: "Budget cost",
  actualCost: "Actual cost",
  expectedResponse: " Expected response",
  numberSent: "Number sent",
  deleteMsg: "Deleted successfully",
  departmentID: "Department ID",
  departmentDeleteMsg: "Deleted successfully",
  viewLabels: {
    contact: "contactView",
    lead: "leadView",
  },
  dateAndTime: "Date & Time",
  enterPassword: "Enter Password",
  changeAccess: "Change Access",
  confirmPassword: "Confirm Password",
  enterUserName: "Enter Username",
  createUser: "Create User",
  user: "User",
  editPermission: "Edit Permission",
  notStarted: "Not Started",
  inProgress: "In Progress",
  completed: "Completed",
  deleteSingleDesc: "Are you sure you want to delete this",
  selectModule: "Select Module",
  fields: "Fields",
  showMore: "Show more",
  showLess: "Show less",
  addNew: "Add New",
  yes: "Yes",
  no: "No",
  notDefined: "not_defined",
  cc: "cc",
  enterEmailAddress: "Enter Email Address",
  defaultTitle: "default-title",
  addField: "Add Field",
  addNote: "Add Note",
  roleAccess: "role-access",
  newAccount: "New Account",
  emailDesc: "Connect a new account to your workspace",
  chooseProvider: "Choose your provider",
  connectGoogle: "Connect with Google",
  connectOutlook: "Connect with Outlook",
  calendar: "Calendar",
  remarksSuccess: "Note saved successfully",
  superAdmin: "superAdmin",
  selectContacts: " Select Contacts from",
  superAdminLabel: "Super Admin",
  passwordChange: "Password changed successfully.",
  loginAgain: "Please log in again.",
  oldPassword: " Current Password",
  changePassword: "Change Password",
  newPassword: "New Password",
  jobOpeningSummary: "Job Opening Summary",
  candidatesSummary: "Candidates Summary",
  confirmNewPassword: "Confirm New Password",
  selctAccounts: "Select Account",
  interviewStatus: "interviewStatus",
  interviewStatusLabel: "Interview Status",
  selectInterviewStatus: "Select Interview Status",
  termCondition:
    "By using Manage360, you agree to the Terms of Service and Privacy Policy",
  welcomeText: "Welcome to Manage360",
  googleSignin: "Sign in with Google",
  fbSignin: "Sign in with Facebook",
  outlookLogin: "Sign in with Outlook",
  whatsUpdate: "What’s the update?",
  shareProposal: "Please share the proposal.",
  cannotAddSameEmail: "Cannot add the same email more than once",
  uploadImageTitle: "Upload",
  successOnboard: "Onboarding Complete!",
  successOnboardDesc: "You’re all set to start using the platform.",
  attactments: "Attachments",
  Login: "Login",
  clear: "Clear",
  interviewDate: "Interview Date",
  resetPassword: "Reset Password",
  sharedBy: "Shared by",
  sharedWith: "Shared with",
  shareViaEmail: "Share Via Email",
  shareManually: "Share Password Manually",
  generatePassword: "Generate Password",
  getStartedNow: "Get Started Now",
  getStartedDesc: "Enter your credentials to access your account",
  donotHaveAccount: "Don’t have an account?",
  signUp: "Sign up",
  forgotPassword: "Forgot Password?",
  endTime: "End Time",
  remember: "Remember",
  interviewMode: "Interview Mode",
  googleSignin: "Sign in with Google",
  fbSignin: "Sign in with Facebook",
  outlookLogin: "Sign in with Outlook",
  whatsUpdate: "What’s the update?",
  shareProposal: "Please share the proposal.",
  cannotAddSameEmail: "Cannot add the same email more than once",
  uploadImageTitle: "Upload",
  successOnboard: "Onboarding Complete!",
  successOnboardDesc: "You’re all set to start using the platform.",
  attactments: "Attachments",
  Login: "Login",
  resetPassword: "Reset Password",
  shareViaEmail: "Share Via Email",
  shareManually: "Share Password Manually",
  generatePassword: "Generate Password",
  getStartedNow: "Get Started Now",
  getStartedDesc: "Enter your credentials to access your account",
  donotHaveAccount: "Don’t have an account?",
  signUp: "Sign up",
  forgotPassword: "Forgot Password?",
  remember: "Remember",
  getStarted: "Get Started",
  completeSteps: "Completed All the following steps",
  step1: {
    title: "Create your workspace",
    description:
      "A shared work environment where you will be able to manage your customer relations with your team.",
    logoLabel: "Workspace logo",
    logoSupportText: "We support your square PNGs, JPEGs and GIFs under 10MB",
    nameLabel: "Workspace name",
    nameDescription: "The name of your organization",
    continueButton: "Continue",
  },
  step2: {
    title: "Create Profile",
    description: "How you'll be identified on the app.",
    pictureLabel: "Picture",
    pictureSupportText:
      "We support your square PNGs, JPEGs and GIFs under 10MB",
    nameLabel: "Name",
    nameDescription: "Your name as it will be displayed on the app",
    continueButton: "Continue",
  },
  step3: {
    title: "Email and Calendar",
    description:
      "Sync your emails and calendar to collaborate better with your team.",
    options: {
      everything: {
        title: "Everything",
        description:
          "Your emails and events content will be shared with your team.",
      },
      subjectMetadata: {
        title: "Subject and metadata",
        description:
          "Your email subjects and meeting titles will be shared with your team.",
      },
      metadata: {
        title: "Metadata",
        description:
          "Only the timestamp and participants will be shared with your team.",
      },
    },
    syncGoogle: "Sync with Google",
    syncOutlook: "Sync with Outlook",
    continueWithoutSync: "Continue without sync",
  },
  step4: {
    title: "Invite your team",
    description: "Get the most out of your workspace by inviting your team.",
    orText: "or",
    copyInvite: "Copy invitation link",
    continueButton: "Continue",
    skipButton: "Skip",
  },
  taskStatus: "Task status updated!",
  failedTaskStatus: "Failed to update task status.",
  Setup: "Setup",
  currency: "Currency",
  selectCurrency: "Select Currency",
  codeSymbol: "Code/Symbol",
  digitSeparators: "Digit Separators",
  decimalPlaces: "Decimal Places",
  setCurrency: "Set Currency",
  roleType: "Role Type",
  selectRoleType: "Select Role Type",
  reportingManager: "Reporting Manager",
  selectReportingManager: "Select Reporting Manager (optional)",
  recruiter: "recruiter",
  employee: "employee",
  overdue: "Overdue",
  notAssigned: "Not Assigned",
  selectIndustry: "Select Industry",
  panel: "Panel",
  additionalInfo: "Additional Info",
  pleaseSlectRecruiterToShareWith: "Please select a recruiter to share with",
  pleaseSelectInterviewsToShare: "Please select interviews to share",
  onlyShareThatYouCreated: "You can only share interviews that you have created yourself",
  interviewsSharedSuccessfully: "shared successfully with",
  importGuidelines: "Import Guidelines",
  makeSureAllrequiredFieldsAreIncluded: "Make sure all required fields are included",
  sourceFieldRule: "Source field value must be one of the following (otherwise it will be left blank):",
  statusFieldRule: "Status field value must be one of the following (otherwise it will be left blank):",
  enterSalaryPerAnnum: "Enter Salary Per Annum",
  enterNumverOfPosition: "Enter Number Of Positions",
  settings: {
    newPasswordPlaceholder: "Enter new password",
    confirmPasswordPlaceholder: "Re-enter new password",
    currentPasswordPlaceholder: "Enter current password",
    userCurrentPassword: "Enter user's current password",
    userCurrentPasswordLabel: "User's Current Password"
  },
  CompanyPolicies: "Company Policies",
  RecruitmentGuide: "Recruitment Guide",
  HolidayCalendar: "Holiday Calendar",
  BenefitsGuide: "Benefits Guide",
  EmailTemplates: "Email Templates",
  OfferTemplates: "Offer Templates",
  AIFeatures: "AI Features",
  JDCreation: "JD Creation",
  Chatbot: "Chatbot",
  feedback: "Feedback",
  performance: {
    // Review Templates
    reviewTemplates: "Review Templates",
    templateName: "Template Name",
    criteriaCount: "Criteria Count",
    failedLoadTemplates: "Failed to load templates",
    templateDeletedSuccess: "Template(s) deleted successfully",
    failedDeleteTemplates: "Failed to delete template(s)",
    reviewTemplate: "Review Template",

    // Cycle Form / Review Cycles
    reviewCycles: "Review Cycles",
    cycleName: "Cycle Name",
    failedLoadCycles: "Failed to load cycles",
    cycleActivatedSuccess: "Cycle activated successfully",
    failedActivateCycle: "Failed to activate cycle",
    cycleCompletedSuccess: "Cycle completed successfully",
    cycleCancelledSuccess: "Cycle cancelled successfully",
    assignReviewers: "Assign Reviewers",
    reviewTemplatePlaceholder: "Select template",
    enableSelfReview: "Enable Self Review",
    complete:'Complete',

    // My Reviews
    myPerformanceReviews: "Self Performance Reviews",
    failedLoadReviews: "Failed to load reviews",
    reviewAcknowledged: "Review acknowledged",
    failedAcknowledgeReview: "Failed to acknowledge review",
    submitReview: "Submit Review",
    acknowledge: "Acknowledge",
    reviewType: "Review Type",
    score: "Score",
    employee: "Employee",
    cycle: "Cycle",
    self: "Self",

    // Modals
    editReviewTemplate: "Edit Review Template",
    createReviewTemplate: "Create Review Template",
    basicInformation: "Basic Information",
    templateNamePlaceholder: "e.g., Annual Performance Review",
    descriptionPlaceholder: "Describe this template...",
    editCriterion: "Edit Criterion",
    addNewCriterion: "Add New Criterion",
    criterionName: "Criterion Name",
    criterionNameRequired: "Criterion name is required",
    criterionNamePlaceholder: "e.g., Productivity, Communication",
    criterionDescriptionPlaceholder: "Describe this criterion...",
    weightLabel: "Weight (0-100)",
    maxRatingLabel: "Max Rating (1-10)",
    cancelEdit: "Cancel Edit",
    updateCriterion: "Update Criterion",
    addCriterion: "Add Criterion",
    addedCriteria: "Added Criteria",
    noCriteriaAdded: "No criteria added yet. Fill the form above and click \"Add Criterion\".",
    criterionUpdated: "Criterion updated",
    criterionAdded: "Criterion added",
    templateNameRequired: "Template name is required",
    atLeastOneCriterion: "Please add at least one criterion",
    templateUpdatedSuccess: "Template updated successfully",
    templateCreatedSuccess: "Template created successfully",
    failedSaveTemplate: "Failed to save template",

    editReviewCycle: "Edit Review Cycle",
    createReviewCycle: "Create Review Cycle",
    cycleNamePlaceholder: "e.g., Q1 2024 Review",
    failedFetchTemplates: "Failed to fetch templates",
    cycleUpdatedSuccess: "Cycle updated successfully",
    cycleCreatedSuccess: "Cycle created successfully",
    failedSaveCycle: "Failed to save cycle",

    failedLoadUsers: "Failed to load users",
    assignAtLeastOneReviewer: "Please assign at least one reviewer",
    reviewersAssignedSuccess: "Reviewers assigned successfully",
    failedAssignReviewers: "Failed to assign reviewers",

    // Cycle Completion Modal
    completeCycleTitle: "Complete Review Cycle",
    completeCycle: "Complete Cycle",
    completeAnyway: "Complete Anyway",
    pendingReviewsWarning: "review(s) are still pending. All reviews must be submitted before the cycle can be completed.",
    allReviewsMustComplete: "All reviews must be submitted or approved before completing the cycle",
    allReviewsComplete: "All reviews have been submitted or approved. Safe to complete.",
    reviews: "Reviews",
    reviewer: "Reviewer",
    manager: "Manager",
    peer: "Peer",
    reviewerPlaceholder: "Select reviewer",
    typePlaceholder: "Select type",
    defaultReviewer: "Default Reviewer",
    defaultReviewType: "Default Review Type",
    defaultReviewerPlaceholder: "Select default reviewer (optional)",

    reviewSubmittedSuccess: "Review submitted successfully",
    failedSubmitReview: "Failed to submit review",
    rating: "Rating",
    overallComment: "Overall Comment",
  }
};
export const iconMapList = {
  'Overview': OverviewIcon,
  'Change Password': KeyPasswordIcon,
  'Integration': (props) => (
    <TbPlugConnected
      {...props}
      style={{
        border: 'none !important',
        outline: 'none !important',
        boxShadow: 'none !important',
        background: 'transparent !important',
        ...props.style
      }}
    />
  ),
  'Roles & Permissions': (props) => (
    <MdAdminPanelSettings
      {...props}
      style={{
        border: 'none !important',
        outline: 'none !important',
        boxShadow: 'none !important',
        background: 'transparent !important',
        ...props.style
      }}
    />
  )
}
export const priorityLabelMap = {
  not_defined: "Not Defined",
  low: "Low",
  medium: "Medium",
  high: "High",
  highest: "Highest",
};
export const createWorkspaceOptions = [
  {
    id: 1,
    label: "Create your Organization",
    description: "Collaborate with your team to manage customer relations.",
  },
  {
    id: 2,
    label: "Sign Up",
    description:
      "Sync your Emails and Calendar with Twenty. Choose your privacy settings.",
  },
  {
    id: 3,
    label: "Email & Calendar",
    description:
      "Sync your Emails and Calendar with Twenty. Choose your privacy settings.",
  },
  {
    id: 4,
    label: "Invite Your Team",
    description: "Get the most out of your workspace by inviting your team.",
  },
];

export const routeNames = {
  applications: "applications",
  candidates: "candidates",
  interviews: "interviews",
  referrals: "referrals",
  departments: "departments",
  campaigns: "campaigns",
  offers: "offers",
  panels: "panels",
  bgVerification: "bg verification",
  jobOpenings: "job openings",
};

export const accessModuleTitles = {
  Applications: "Applications",
  JobOpenings: "Job Openings",
  Candidates: "Candidates",
  Interviews: "Interviews",
  Referrals: "Referrals",
  Departments: "Departments",
  Feedbacks: "Feedbacks",
  Feedback: 'Feedback',
  MyInterviews: "My Interviews",
  MyFeedback: "My Feedbacks",
  MyReferrals: "My Referrals",
  Dashboard: "Dashboard",
  Todo: "Todo",
  Recruitment: "Recruitment",
  Offers: "Offers",
  Panels: "Panels",
  bgVerification: "BG Verification",
  DocumentVerification: "Document Verification",
  CompanyPolicies: "Company Policies",
  RecruitmentGuide: "Recruitment Guide",
  HolidayCalendar: "Holiday Calendar",
  BenefitsGuide: "Benefits Guide",
  EmailTemplates: "Email Templates",
  OfferTemplates: "Offer Templates",
  AIFeatures: "AI Features",
  JDCreation: "JD Creation",
  Chatbot: "Chatbot",
  OnboardingChecklist: "Onboarding Checklist",
  ChecklistTemplates: "Checklist Templates",
  MyTasks: "My Tasks",
  OnboardingReview: "Onboarding Review",
  ReviewCycles: "Review Cycles",
  ReviewTemplates: "Review Templates",
  MyReviews: "My Reviews",
  ReviewsAboutMe: "Reviews About Me",
  TeamReviews: "Team Reviews",
  PerformanceAnalytics: "Performance Analytics",
  Assignments: "Assignments",
  Approvals: "Approvals"
};

export const jobStatusOptions = [
  "Open",
  "In Progress",
  "On Hold",
  "Filled",
  "Cancelled",
  "Closed",
  "Draft",
];

export const applicationStatusLabels = [
  "Open",
  "Not Assigned",
  "Assignment Shared",
  "Assignment In Review",
  "Documentation Complete",
  "Documentation In Progress",
  "Hold",
  "Intent to Offer",
  "Joined",
  "No Show",
  "R1 Rejected",
  "R1 Scheduled",
  "R1 Selected",
  "R2 Rejected",
  "R2 Scheduled",
  "R2 Selected",
  "R3 Rejected",
  "R3 Scheduled",
  "R3 Selected",
  "Rejected",
  "Selected",
  "Shortlisted",
  "Position Closed",
];

export const canddiateStatusLabels = [
  'new',
  'screening',
  'shortlisted',
  'interview',
  'offered',
  'hired',
  'rejected',
  'engaged',
  'withdrawn'
]

export const CANDIDATE_STATUS = {
  NEW: 'new',
  SCREENING: 'screening',
  SHORTLISTED: 'shortlisted',
  INTERVIEW: 'interview',
  OFFERED: 'offered',
  HIRED: 'hired',
  REJECTED: 'rejected',
  ENGAGED: 'engaged',
  WITHDRAWN: 'withdrawn'
};

export const candidateStatusOptions = [
  { label: "New", value: CANDIDATE_STATUS.NEW },
  { label: "Screening", value: CANDIDATE_STATUS.SCREENING },
  { label: "Shortlisted", value: CANDIDATE_STATUS.SHORTLISTED },
  { label: "Interview", value: CANDIDATE_STATUS.INTERVIEW },
  { label: "Offered", value: CANDIDATE_STATUS.OFFERED },
  { label: "Hired", value: CANDIDATE_STATUS.HIRED },
  { label: "Rejected", value: CANDIDATE_STATUS.REJECTED },
  { label: "Engaged", value: CANDIDATE_STATUS.ENGAGED },
  { label: "Withdrawn", value: CANDIDATE_STATUS.WITHDRAWN },
];

export const interviewStatusLabels = [
  "scheduled",
  "in-progress",
  "completed",
  "feedback-submitted",
  "cancelled"
];

export const candidateStageOptionsLabels = [
  "Sourced",
  "Contacted",
  // "Applied",
  "Screening",
  "Interview",
  "Offered",
  "Hired",
  "Rejected",
  "Withdrawn",
  "On Hold",
  "Pending",
];

export const feedbackConstants = {
  feedback: "Feedback",
  createFeedback: "Create Feedback",
  candidateName: "Candidate Name",
  postingTitle: "Posting Title",
  rating: "Rating",
  createdBy: "Created By",
  editFeedback: "Edit Feedback",
  interview: "Interview",
  interviewRound: "Interview Round",
  interviewId: "Interview ID",
  viewFeedback: "View Feedback",
  feedbackSubmitted: "Feedback Submitted",
  feedbackSubmittedDash: "feedback-submitted",
  completed: "Completed",
  recruiter: "recruiter",
  // New feedback form fields
  interviewPanelMembers: "Panel",
  selectPanelMembers: "Select panel members",
  profilePosition: "Profile (Position)",
  technicalKnowledge: "Technical Knowledge",
  technicalKnowledgeDetails: "Please specify details for Technical Knowledge",
  communication: "Communication",
  communicationAverage: "Average",
  communicationGood: "Good",
  communicationExcellent: "Excellent",
  problemSolvingSkills: "Problem-Solving Skills ",
  problemSolvingDetails: "Please specify details for Problem-Solving",
  finalRating: "Rating",
  experienceInYears: "Experience",
  selectExperienceRange: "Select experience range",
  recommendedAction: "Recommendation",
  selectRecommendedAction: "Select Recommended Action",
  selectCandidateName: "Select Candidate Name",
  selectInterview: "Select Interview",
  technicalInterviewQuestions: "Technical Interview Questions",
  practicalSkillsAssessmentQuestions: "Practical Skills Assessment Questions",
  additionalQuestions: "Additional Questions",
  finalComments: "Final Comments",
  comments: "Comments",
}

export const referralTabs = [
  { label: 'Referral Details', Icon: JobOpeningIcon },
]
